import "../../assets/css/clientsAdminView/clientsAdminView.css"

import status from "../../assets/images/status.svg"
import industry from "../../assets/images/industries.svg"
import location from "../../assets/images/location.svg"

import { useAuth } from "../../context/auth-user"
import { useNavigate } from "react-router-dom"
import { BATCH_SIZE, useClientsTable } from "./hooks/useClientsTable"
import { ClientFilter } from "./components/ClientFilter"
import { ClientsTable } from "./components/ClientsTable"
import PageSelector from "../pageSelector"


export default function ClientsAdminView() {
    const navigate = useNavigate();
    
    const { user } = useAuth()
    const userLogged = user?.selectedProfile
    const darkLightMode = userLogged?.darkLightMode

    const {
		currentPage,
        totalPages,
        totalCount,
		handlePageChange,
		
		industriesData,
        locationsData,

		openFilter,
		filterOptions,
        handleOpenFilter,
		handleSelectFilterOption,
		handleApplyFilter,
		handleClearFilter,
		
		handleShowSortMenu,
		showSortMenu,
		handleSortChange,
		
		searchValue,
		handleSearchChange,
		handleSetSearchFilter,

		sortMenuRef,
		showResetFilters,
		handleResetAllFilters
    } = useClientsTable()

	const statusOptions = (
		<>
			<div className="option">
				<input checked={filterOptions.status.includes("Active")} className="statusCheck" value="Active" type="checkbox" id={`statusActive`} onChange={() => handleSelectFilterOption("status", "Active")} />
				<label htmlFor={`statusActive`}>Active</label>
			</div>

			<div className="option">
				<input checked={filterOptions.status.includes("Disable")} className="statusCheck" value="Disable" type="checkbox" id={`statusDisable`} onChange={() => handleSelectFilterOption("status", "Disable")} />
				<label htmlFor={`statusDisable`}>Disable</label>
			</div>
		</>
	)

	const industriesOptions = (
		<>
			{industriesData.map(industry => {
				const industryName = industry.industryName

				return (
					<div key={industryName} className="option">
						<input 
							checked={filterOptions.industry.includes(industryName)} 
							className="industryCheck" 
							value={industryName} 
							type="checkbox" 
							id={industryName} 
							onChange={() => handleSelectFilterOption("industry", industryName)} 
						/>

						<label htmlFor={industryName} >{industryName}</label>
					</div>
				)
			})}
		</>
	)
	
	const locationsOptions = (
		<>
			{locationsData.map(location => {
				const locationName = location.locationName
				
				return (
					<div key={`${locationName}-filter-option`} className="option">
						<input 
							checked={filterOptions.location.includes(locationName)} 
							className="industryCheck" 
							value={locationName} 
							type="checkbox" 
							id={locationName} 
							onChange={() => handleSelectFilterOption("location", locationName)} 
						/>

						<label htmlFor={locationName}>{locationName}</label>
					</div>
				)
			})}
		</>
	)

    return (
		<section className={`clientsAdminView ${darkLightMode ? "darkMode" : null}`}>
			<div className="titleAndSearch">
				<h3 className="title">Clients</h3>

				<div className="searchAndSort">
					<form onSubmit={handleSetSearchFilter}>
						<div className={`searchContainer ${darkLightMode ? "darkMode" : null}`}>
							<input id="generalSearch" placeholder="Search by name..."
								value={searchValue} onChange={handleSearchChange} />
						</div>

						<button className='applySearchButton' type="submit"></button>
					</form>

					<button ref={sortMenuRef} className="d-lg-none sortMobile" onClick={handleShowSortMenu}>Sort</button>

					<div className={`d-lg-none sortDataContainer ${showSortMenu ? "show" : ""}`}>
						<h5 className="title">Sort</h5>
						<span onClick={() => handleSortChange("name", "ASC")}>Name (ascending)</span>
						<span onClick={() => handleSortChange("name", "DSC")}>Name (descending)</span>
						<span onClick={() => handleSortChange("industry", "ASC")}>Industry (ascending)</span>
						<span onClick={() => handleSortChange("industry", "DSC")}>Industry (descending)</span>
						<span onClick={() => handleSortChange("location", "ASC")}>Location (ascending)</span>
						<span onClick={() => handleSortChange("location", "DSC")}>Location (descending)</span>
						<span onClick={() => handleSortChange("status", "ASC")}>Status (ascending)</span>
						<span onClick={() => handleSortChange("status", "DSC")}>Status (descending)</span>
						<span onClick={() => handleSortChange("createdAt", "ASC")}>Registration (ascending)</span>
						<span onClick={() => handleSortChange("createdAt", "DSC")}>Registration (descending)</span>
						<span onClick={() => handleSortChange("entitiesCount", "ASC")}>Entities (ascending)</span>
						<span onClick={() => handleSortChange("entitiesCount", "DSC")}>Entities (descending)</span>
					</div>
				</div>
			</div>

			<div className={`filters ${darkLightMode ? "darkMode" : null}`}>
				<ClientFilter
					icon={status}
					title="Status"
					filterOptions={statusOptions}
					openFilter={openFilter}
					onFilterClick={handleOpenFilter}
					onFilterApply={handleApplyFilter}
					onFilterClear={handleClearFilter}
				/>

				<ClientFilter
					icon={industry}
					title="Industry"
					filterOptions={industriesOptions}
					openFilter={openFilter}
					onFilterClick={handleOpenFilter}
					onFilterApply={handleApplyFilter}
					onFilterClear={handleClearFilter}
				/>

				<ClientFilter
					icon={location}
					title="Location"
					filterOptions={locationsOptions}
					openFilter={openFilter}
					onFilterClick={handleOpenFilter}
					onFilterApply={handleApplyFilter}
					onFilterClear={handleClearFilter}
				/>

				<button className="btnBgBlueTextGradient" onClick={() => navigate("./registerClient/")}>New Client</button>
			</div>

			<span className={`resetAll ${showResetFilters ? "show" : ""}`} onClick={handleResetAllFilters}>Reset All</span>

			<ClientsTable onSortChange={handleSortChange} />

			<PageSelector 
				className="clientsTablePagination"
				currentPage={currentPage ?? 1}
				totalItems={totalCount ?? 0}
				itemsPerPage={BATCH_SIZE}
				onChange={handlePageChange}
			/>
			<span className="tableCount">{currentPage} of {totalPages ?? 1}</span>

			<button className="btnBgBlueTextGradient d-lg-none" onClick={() => navigate("./registerClient/")}>New Client</button>
		</section>
	)
}
